module.exports = __webpack_public_path__ + "img/46-mensagens-recebidas-lista.d337c74e.png";